import React, { useCallback } from 'react';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faCircleDashed } from '@fortawesome/pro-solid-svg-icons/faCircleDashed';

import PropTypes from 'prop-types';

import { ReturnStatus } from '../../../../enums/return-status';
import { useEntitiesReturnProperty } from '../../../../hooks/entities/selectors/returns';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { useReturnIdContext } from '../../context/return-id-context-provider';
import { useReturnNavigation } from '../../hooks/use-return-navigation';
import { ReturnCounter } from '../../return';
import { NavigationButton } from '../navigation-panel/navigation-button';
import { RETURN_SIDEBAR_CLICKED } from '../../../../constants/analytics-events';
import { Segment } from '../../../../services/analytics-services/segment';

import style from './returns-panel-button.module.less';

const statusToIconMap = {
  [ReturnStatus.Received.toString()]: {
    icon: faCheckCircle,
    iconClassName: style['received-icon'],
  },
};

const defaultIcon = {
  icon: faCircleDashed,
  iconClassName: style['default-icon'],
};

export const ReturnsPanelButton = ({ returnFulfillmentId, counter, isNewReturn }) => {
  const salesOrderId = useSalesOrderIdContext();
  const selectedReturnId = useReturnIdContext();

  const isSelected = !!selectedReturnId && selectedReturnId === returnFulfillmentId;

  const { navigateToReturn } = useReturnNavigation();

  const navigateTo = useCallback(() => {
    Segment.trackEvent(RETURN_SIDEBAR_CLICKED, {
      type: RETURN_SIDEBAR_CLICKED,
      enhanced: false,
      fulfillmentId: returnFulfillmentId,
      salesOrderId,
    });
    navigateToReturn(salesOrderId, returnFulfillmentId);
  }, [navigateToReturn, returnFulfillmentId, salesOrderId]);

  const returnStatus = useEntitiesReturnProperty(returnFulfillmentId, 'returnStatus');
  const { icon, iconClassName } = statusToIconMap[returnStatus] || defaultIcon;

  return (
    <NavigationButton icon={icon} iconClassName={iconClassName} isSelected={isSelected} onClick={navigateTo}>
      <ReturnCounter counter={counter} isNewReturn={isNewReturn} />
    </NavigationButton>
  );
};

ReturnsPanelButton.propTypes = {
  counter: PropTypes.number.isRequired,
  isNewReturn: PropTypes.bool.isRequired,
  returnFulfillmentId: PropTypes.string.isRequired,
};
